'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');

const DialogContext = React.createContext({
    fullscreen: false,
});

exports.default = DialogContext;
//# sourceMappingURL=DialogContext.js.map
